module.exports = __webpack_public_path__ + "img/ehd-m.3ddda8a7.jpg";